import {
    Box, Button, Grid, Typography, useMediaQuery, useTheme
  } from '@mui/material'
  import React, { useEffect, useState } from 'react'
  import { Link } from 'react-router-dom'
  import { toast } from 'react-toastify'
  import { DotLottieReact } from '@lottiefiles/dotlottie-react'
  import { useSpring, animated } from '@react-spring/web'
  
  const BookingTracking = () => {
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  
    const [trackingCode, setTrackingCode] = useState('')
    const [showMain, setShowMain] = useState(false)
  
    useEffect(() => {
      const code = Math.floor(100000 + Math.random() * 900000).toString()
      setTrackingCode(code)
  
      const timer = setTimeout(() => {
        setShowMain(true)
      }, 5000)
  
      return () => clearTimeout(timer)
    }, [])
  
    // Animation styles
    const fadeStyles = useSpring({
      opacity: showMain ? 0 : 1,
      config: { duration: 800 }
    })
  
    const slideStyles = useSpring({
      transform: showMain ? 'translateY(0)' : 'translateY(100%)',
      opacity: showMain ? 1 : 0,
      config: { tension: 200, friction: 20 }
    })
  
    const handleConfirmSetting = async () => {
      try {
        await navigator.clipboard.writeText(trackingCode)
        toast.success('کد رزرو با موفقیت کپی شد')
      } catch (err) {
        toast.error('خطا در کپی کردن کد رزرو')
      }
    }
  
    return (
      <div
        className='container'
        style={{
          padding: isLargeScreen ? '60px 40px' : '30px 20px',
          backgroundColor: 'white',
          borderRadius: '10px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden'
        }}
      >
        {/* Animation Section */}
        {!showMain && (
          <animated.div style={fadeStyles}>
            <Grid>
              <DotLottieReact
                src="./assets/animations/Animation.lottie"
                autoplay
              />
              <Typography
                variant={isLargeScreen ? 'h1' : 'h2'}
                align="center"
                sx={{ fontWeight: 600, color: '#3E7B27' }}
              >
                پرداخت موفق
              </Typography>
            </Grid>
          </animated.div>
        )}
  
        {/* Main Section with drawer slide-in */}
        <animated.div style={slideStyles}>
          {showMain && (
            <Grid>
              <Typography
                variant={isLargeScreen ? 'h1' : 'h2'}
                align="center"
                sx={{ fontWeight: 600, color: 'black', mb: '64px' }}
              >
                پیگیری رزرو
              </Typography>
              <Box sx={{ mb: "64px" }}>
                <Typography
                  color={theme.palette.info.dark}
                  variant={isLargeScreen ? 'h5' : 'h6'}
                  align="center"
                  mb={'24px'}
                >
                  كد رزرو خود را به خاطر بسپاريد
                </Typography>
                <Grid className='codeReserve'>
                  <Typography
                    variant={isLargeScreen ? 'h2' : 'h3'}
                    align="center"
                    sx={{ fontWeight: 600, color: '#6069E7', mb: '64px' }}
                  >
                    {trackingCode}
                  </Typography>
                </Grid>
              </Box>
              <Box sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2
              }}>
                <Box sx={{ width: '50%' }}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleConfirmSetting}
                    sx={{
                      height: '48px',
                      py: 1.5,
                      px: 3,
                      borderRadius: 1,
                      fontSize: isLargeScreen ? '16px' : '14px',
                      fontWeight: 700,
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: 6
                      },
                      transition: 'all 0.3s'
                    }}
                  >
                    {'کپی'}
                  </Button>
                </Box>
                <Box sx={{ width: '50%' }}>
                  <Button
                    component={Link}
                    to={'/'}
                    fullWidth
                    variant="outlined"
                    sx={{
                      height: '48px',
                      py: 1.5,
                      px: 3,
                      borderRadius: 1,
                      fontSize: isLargeScreen ? '16px' : '14px',
                      fontWeight: 700,
                      color: 'primary.main',
                      borderColor: 'primary.main',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: 6,
                        borderColor: 'primary.main'
                      },
                      transition: 'all 0.3s'
                    }}
                  >
                    {'بازگشت'}
                  </Button>
                </Box>
              </Box>
            </Grid>
          )}
        </animated.div>
      </div>
    )
  }
  
  export default BookingTracking
  